import { useEffect, useState } from 'react';

export const useCheckVaildSubmit = ({ ccrcInputs }) => {
  const [isVaildSubmit, setIsVaildSubmit] = useState(false);
  const [allChecked, setAllChecked] = useState(false);

  useEffect(() => {
    let _allChecked = true;
    const isValid = Object.values(ccrcInputs).every(({ checked, essnYn }) => {
      if (!checked) _allChecked = false;

      if (!essnYn) {
        return true;
      }
      if (checked) return true;
      return false;
    });

    if (isValid) setIsVaildSubmit(true);
    else setIsVaildSubmit(false);
    setAllChecked(_allChecked);
  }, [ccrcInputs]);

  return [isVaildSubmit, allChecked];
};
